export default __webpack_public_path__ + "Powershades_Logo_White.png";